export const addLineBreaks = (text) => {
  return text.split("@@").map((sentence, index) => (
    <span key={index}>
      {sentence.trim()}
      {index < text.split("@@").length - 1 && <br />} {/* Don't add <br> after the last sentence */}
    </span>
  ));
};